export const GOOGLE_PLACES_SCRIPT_ID = "google-places-search-area-input";
export const GOOGLE_PLACES_LIBRARY = "places";
export const GOOGLE_PREDICTION_DEBOUNCE_MS = 400;
export const SEARCH_AREA_INPUT_SELECTOR =
  "input[data-search-area-input='true']";
export const SEARCH_AREA_SUGGESTIONS_SELECTOR =
  "[data-search-area-suggestions]";
export const SEARCH_AREA_SUGGESTION_SELECTOR = ".search-area-input__suggestion";
export const SEARCH_AREA_ACTIVE_SUGGESTION_CLASS =
  "search-area-input__suggestion--active";
export const SEARCH_AREA_SUGGESTION_INDEX_ATTRIBUTE =
  "data-search-area-suggestion-index";
export const UK_COUNTRY_SUFFIX = ", UK";
